/**
 * Format a UTC timestamp to local time with timezone
 * @param {string|Date} timestamp - UTC timestamp
 * @returns {string} Formatted local date string
 */
export function formatDateTime(timestamp) {
  if (!timestamp) return 'Unknown';
  const utcTimestamp = timestamp.endsWith('Z') ? timestamp : timestamp + 'Z';
  return new Date(utcTimestamp).toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short'
  });
}

/**
 * Format a UTC timestamp to local date only
 * @param {string|Date} timestamp - UTC timestamp
 * @returns {string} Formatted local date string
 */
export function formatDate(timestamp) {
  if (!timestamp) return 'Unknown';
  const utcTimestamp = timestamp.endsWith('Z') ? timestamp : timestamp + 'Z';
  
  return new Date(utcTimestamp).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

/**
 * Format a UTC timestamp to local time only
 * @param {string|Date} timestamp - UTC timestamp
 * @returns {string} Formatted local time string
 */
export function formatTime(timestamp) {
  if (!timestamp) return 'Unknown';
  const utcTimestamp = timestamp.endsWith('Z') ? timestamp : timestamp + 'Z';
  
  return new Date(utcTimestamp).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short'
  });
}
